.policy-grid-item-form {

  &--row, &--actions {
    margin-top: calc(2 * var(--spacer));
  }

  &--field {
    margin-right: calc(2 * var(--spacer));
    position: relative;
    height: calc(2 * var(--spacer));
  }

  &--icon {
    margin-top: calc(1.5 * var(--spacer));
    margin-left: calc(-2 * var(--spacer));
    margin-right: calc(var(--spacer));
  }

  .input {
    &--w20 {
      width: 20%;
    }

    &--w25 {
      width: 25%;
    }
    &--w30 {
      width: 30%;
    }

    &--w40 {
      width: 40%;
    }

    &--w50 {
      width: 50%;
    }

    &--w70 {
      width: 70%;
    }
  }
}

:host {
  height: 0;
  margin-bottom: 50px;
}

@media screen and (max-height: 768px) {
  gz-dropdown {
    --gz-dropdown-max-height: 200px !important;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-single-select.focus {
  --dropdown-border-top: 1px solid var(--blue-layout-400-primary);
  --dropdown-border-bottom: 1px solid var(--blue-layout-400-primary);
  --dropdown-border-left: 1px solid var(--blue-layout-400-primary);
  --dropdown-border-right: 1px solid var(--blue-layout-400-primary);
}
